import React from 'react'
import { Form, Switch, Tooltip } from 'antd'
import { FileExclamationOutlined, FilePdfOutlined } from '@ant-design/icons'
import cn from 'classnames'
import { useIntl } from 'react-intl'

import styles from './email-method.module.scss'

export const EmailAttachmentToggleColumn = ({
  title,
  fileName,
  fieldName,
  onFileClick,
  disabled,
  unavailableMessage,
}) => {
  const isUnavailable = !fileName
  const canClick = !!onFileClick && !!fileName && !disabled

  const switchElement = fieldName ? (
    <Form.Item name={fieldName} valuePropName="checked" noStyle>
      <Switch disabled={disabled} className={styles.attachmentSwitch} />
    </Form.Item>
  ) : null

  return (
    <div
      className={cn(styles.attachmentColumn, isUnavailable && styles.attachmentColumnUnavailable)}
    >
      <span className={styles.attachmentTitle}>{title}</span>
      <div className={styles.attachmentBody}>
        <div className={styles.attachmentFile}>
          {isUnavailable ? (
            <FileExclamationOutlined className={styles.unavailableIcon} />
          ) : (
            <FilePdfOutlined className={styles.pdfIcon} />
          )}
          {fileName ? (
            canClick ? (
              <button
                type="button"
                className={styles.attachmentFileName}
                onClick={onFileClick}
                title={fileName}
              >
                {fileName}
              </button>
            ) : (
              <span className={styles.attachmentFileName} title={fileName}>
                {fileName}
              </span>
            )
          ) : (
            <span className={styles.attachmentUnavailableText}>{unavailableMessage}</span>
          )}
        </div>
        {switchElement &&
          (disabled && unavailableMessage ? (
            <Tooltip title={unavailableMessage}>
              <span className={styles.attachmentSwitchWrapper}>{switchElement}</span>
            </Tooltip>
          ) : (
            switchElement
          ))}
      </div>
    </div>
  )
}

const EmailAttachmentToggleRows = ({
  invoiceFileName,
  relatedAttachments,
  showToggles,
  onPrintInvoicePdf,
  onPrintOrderPdf,
  onPrintDeliveryPdf,
}) => {
  const { formatMessage } = useIntl()

  if (showToggles) {
    return (
      <div className={styles.attachmentList}>
        <EmailAttachmentToggleColumn
          title={formatMessage({ id: 'emails.invoice_attachment_file' })}
          fileName={invoiceFileName}
          onFileClick={onPrintInvoicePdf}
          disabled={!invoiceFileName}
        />
        <EmailAttachmentToggleColumn
          title={formatMessage({ id: 'emails.order_attachment_file' })}
          fileName={relatedAttachments.order ? `${relatedAttachments.order.ref_number}.pdf` : null}
          fieldName="include_attachment_order"
          onFileClick={onPrintOrderPdf}
          disabled={!relatedAttachments.order}
          unavailableMessage={formatMessage({ id: 'emails.order_attachment_unavailable' })}
        />
        <EmailAttachmentToggleColumn
          title={formatMessage({ id: 'emails.delivery_attachment_file' })}
          fileName={
            relatedAttachments.delivery ? `${relatedAttachments.delivery.ref_number}.pdf` : null
          }
          fieldName="include_attachment_delivery"
          onFileClick={onPrintDeliveryPdf}
          disabled={!relatedAttachments.delivery}
          unavailableMessage={formatMessage({ id: 'emails.delivery_attachment_unavailable' })}
        />
      </div>
    )
  }

  if (!invoiceFileName) {
    return null
  }

  return (
    <div className={styles.attachmentList}>
      <EmailAttachmentToggleColumn
        title={formatMessage({ id: 'emails.invoice_attachment_file' })}
        fileName={invoiceFileName}
        onFileClick={onPrintInvoicePdf}
      />
    </div>
  )
}

export default EmailAttachmentToggleRows
